export const TextColor = '#161616';
export const secondTextColor = '#fafafa';
export const accentTextColor = '#8e0e00';

export const BgColor = '#fafafa';
export const secondBgColor = '#161616';
export const accentBgColor = '#8e0e00';

export const HoverEfect = '250ms linear';
// export const Gradient = 'linear-gradient(to right, #8e0e00, #1f1c18)';
export const Gradient = '#45acda';

export const MainBgColor = '#f4e243';
